import { propClassName } from '@/styles/NewsletterSignup';
import { ClassNameProp, Component, ComponentProps } from '@/types/component';
import { cn } from '@/utils/cn';

export interface NewsletterSignupFieldsetCaptionProps extends ComponentProps<'p'> {
  colors?: ClassNameProp<'primary' | 'secondary'>;
  size?: ClassNameProp<'default'>;
  variant?: ClassNameProp<'default'>;
}

export const NewsletterSignupFieldsetCaptionComponent: Component<NewsletterSignupFieldsetCaptionProps> = ({
  colors,
  size,
  variant,
  className,
  children,
  ...props
}) => {
  const colorsClassName = propClassName('fieldset_caption_colors', colors, 'primary');
  const sizeClassName = propClassName('fieldset_caption_size', size ?? variant, 'default');
  const variantClassName = propClassName('fieldset_caption_variant', variant, 'default');
  const componentClassName = cn(colorsClassName, sizeClassName, variantClassName, className);

  return (
    <p className={componentClassName} {...props}>
      {children}
    </p>
  );
};
